import { render, staticRenderFns } from "./TreasureFind.vue?vue&type=template&id=80812eb6&scoped=true"
import script from "./TreasureFind.vue?vue&type=script&lang=js"
export * from "./TreasureFind.vue?vue&type=script&lang=js"
import style0 from "./TreasureFind.vue?vue&type=style&index=0&id=80812eb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80812eb6",
  null
  
)

export default component.exports